import { createContext, FC, useState } from 'react';
import { ENABLE_DEBUG_MODE, IS_DEV } from '../config/env-config';
import useDebugModeContext from '../hooks/useDebugModeContext';

export type LoggerFunction = (...args: unknown[]) => void;
export type LoggerContextType = {
  log: LoggerFunction;
  warn: LoggerFunction;
  error: LoggerFunction;
};
export const LoggerContext = createContext<LoggerContextType>(null as any);

type Props = {
  children: React.ReactNode;
};
const LoggerProvider: FC<Props> = ({ children }) => {
  const debugCtx = useDebugModeContext();
  const log: LoggerFunction = (...args) => {
    if (IS_DEV) {
      console.log('[LOG]', ...args);
    }
    if (ENABLE_DEBUG_MODE) {
      debugCtx.addMessage(JSON.stringify(args));
    }
  };
  const warn: LoggerFunction = (...args) => {
    if (IS_DEV) {
      console.warn('[WARN]', ...args);
    }
    if (ENABLE_DEBUG_MODE) {
      debugCtx.addMessage(JSON.stringify(args));
    }
  };
  const error: LoggerFunction = (...args) => {
    console.error('[ERROR]', ...args);
    if (ENABLE_DEBUG_MODE) {
      debugCtx.addMessage(JSON.stringify(args));
    }
  };
  return <LoggerContext.Provider value={{ log, warn, error }}>{children}</LoggerContext.Provider>;
};
export default LoggerProvider;
